import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";
import ateezImage1 from "@/assets/ateez-group-photo-1.jpg";
import ateezImage2 from "@/assets/ateez-group-photo-2.webp";
import ateezImage3 from "@/assets/ateez-concert-photo.jpg";

const StudyWithAteez = () => {
  return (
    <KpopStudyPageTemplate
      groupName="ateez"
      groupNameDisplay="ATEEZ"
      fandomName="ATINY"
      seoTitle="Study With ATEEZ - ATINY Study Rooms"
      seoDescription="Study with ATEEZ fans worldwide. Join ATINYs in virtual study rooms with ATEEZ playlists, themed spaces, and 24/7 study sessions for powerful productivity."
      seoKeywords="study with ateez, ateez study room, atiny study, kpop study room, ateez playlist study"
      canonicalUrl="/study-with-ateez/"
      heroDescription="Join ATINYs worldwide who study with ATEEZ's passionate and powerful energy. Set sail toward your goals with their fierce determination."
      aboutContent="ATEEZ is a South Korean boy group formed by KQ Entertainment, known for their powerful performances and pirate concept. The group consists of eight members: Hongjoong, Seonghwa, Yunho, Yeosang, San, Mingi, Wooyoung, and Jongho. With hits like 'HALA HALA,' 'Wonderland,' and 'Guerrilla,' ATEEZ has captivated fans with their intense energy and passion."
      riseOfContent="ATINYs find inspiration in ATEEZ's determination and fearless approach to challenges. Studying with ATEEZ means channeling that same passionate energy into your work, staying focused on your goals, and conquering every challenge that comes your way."
      featureCards={[
        { title: "ATEEZ Study Playlists", desc: "Power through your studies with curated ATEEZ playlists featuring their most intense and motivating tracks that fuel your determination." },
        { title: "ATINY Crew Community", desc: "Join fellow ATINYs from around the world in dedicated study rooms where crew members support each other's academic journeys." },
        { title: "Pirate-Themed Spaces", desc: "Navigate your studies in ATEEZ-themed rooms with bold aesthetics inspired by their pirate concept and powerful stage presence." },
        { title: "Treasure Hunt Sessions", desc: "Embark on your academic treasure hunt 24/7 with ATEEZ's powerful energy pushing you to discover and achieve your full potential." }
      ]}
      whyPerfectDescription="CSW provides the perfect environment for ATINYs to channel ATEEZ's powerful energy into productive study sessions. With themed study rooms, curated playlists, and a supportive community, you can set sail toward your academic goals alongside fellow fans who share your passion."
      communityDescription1="Connect with ATINYs from across the globe who share your love for ATEEZ and your dedication to academic success."
      communityDescription2="Join study sessions inspired by ATEEZ's fierce determination and pirate spirit. Together, we conquer every challenge."
      socialLinks={[
        { name: "Official Website", url: "https://ateez.kqent.com/" },
        { name: "Instagram", url: "https://www.instagram.com/ateez_official_/" },
        { name: "Twitter/X", url: "https://twitter.com/ATEEZofficial" },
        { name: "YouTube", url: "https://www.youtube.com/@ATEEZ" },
        { name: "Spotify", url: "https://open.spotify.com/artist/68KmkJeZGfwe1OUaivBa2L" },
        { name: "TikTok", url: "https://www.tiktok.com/@ateez_official" }
      ]}
      youtubeVideos={[
        { id: "0R6tRuVFVrQ", title: "Guerrilla" },
        { id: "Z9aczxGCPRM", title: "HALAZIA" },
        { id: "p1bjnyDqI9k", title: "Wonderland" },
        { id: "eLfpeg3Ld1g", title: "Answer" },
        { id: "2NArH91kHoQ", title: "Say My Name" },
        { id: "QbjmVyP9RFg", title: "HALA HALA" }
      ]}
      youtubeChannelUrl="https://www.youtube.com/@ATEEZ"
      youtubeChannelName="ATEEZ"
      image1={ateezImage1}
      image2={ateezImage2}
      image3={ateezImage3}
    />
  );
};

export default StudyWithAteez;
